import { render, staticRenderFns } from "./IDFinder.vue?vue&type=template&id=a2796ab6&scoped=true"
import script from "./IDFinder.vue?vue&type=script&lang=js"
export * from "./IDFinder.vue?vue&type=script&lang=js"
import style0 from "./IDFinder.vue?vue&type=style&index=0&id=a2796ab6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2796ab6",
  null
  
)

export default component.exports